import { Box, Flex, Heading, Link, Text, VStack } from '@chakra-ui/react';
import { NumberedStep } from '../../v2qs/numbered-step';
import { InfoBox } from '../../v2qs/info-box';

export const SupportStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={6} maxW="500px" w="full">
        {/* Chat Icon */}
        <Flex justify="center" pt={4}>
          <Box w="80px" h="80px">
            <img
              src={`${import.meta.env.BASE_URL}images/support.webp`}
              alt="Support chat"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </Box>
        </Flex>

        {/* Title */}
        <Heading
          fontSize={{ base: '2xl', md: '3xl' }}
          fontWeight="black"
          color="green.500"
          textTransform="uppercase"
          textAlign="center"
        >
          Need Support?
        </Heading>

        {/* Subtitle */}
        <Text fontSize="md" color="gray.800" fontWeight="semibold" textAlign="center">
          You can seek support via 3 channels:
        </Text>

        {/* Support Options */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={4}>
            <NumberedStep number={1}>
              <Text as="span">
                <Text as="span" fontWeight="bold">
                  FrogBox Go Chat
                </Text>{' '}
                - Live chat with us on match days when logged into your FrogBox
                Go account. Click the{' '}
                <Text as="span" fontWeight="bold">
                  'CHAT'
                </Text>{' '}
                icon on the bottom right. To do this, you'll need to be logged
                in as a user.
              </Text>
            </NumberedStep>
          </VStack>
        </Box>

        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={4}>
            <NumberedStep number={2}>
              <Text as="span">
                Live chat with us on match days by texting{' '}
                <Text as="span" fontWeight="bold">
                  +61 405 300 122
                </Text>
                . To do this, you'll need to have{' '}
                <Link
                  href="https://www.whatsapp.com/"
                  color="green.600"
                  fontWeight="semibold"
                  textDecoration="underline"
                  _hover={{ color: 'green.700' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WhatsApp downloaded
                </Link>{' '}
                onto your phone.
              </Text>
            </NumberedStep>
          </VStack>
        </Box>

        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={4}>
            <NumberedStep number={3}>
              <Text as="span">
                You can also submit a ticket here:{' '}
                <Link
                  href="https://frogbox.freshdesk.com/support/tickets/new"
                  color="green.600"
                  fontWeight="semibold"
                  textDecoration="underline"
                  _hover={{ color: 'green.700' }}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Submit a ticket
                </Link>
              </Text>
            </NumberedStep>
          </VStack>
        </Box>

        {/* Info Box */}
        <Box w="full">
          <InfoBox>
            Click the following link for access to full library of{' '}
            <Link
              href="https://frogbox.freshdesk.com/support/solutions/51000320710"
              color="green.600"
              fontWeight="semibold"
              textDecoration="underline"
              _hover={{ color: 'green.700' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              how to guides and operating tips
            </Link>
            .
          </InfoBox>
        </Box>
      </VStack>
    </Flex>
  );
};
